import { useContext } from 'react';
import { TechnicalErrorContext } from '../context/technical-error-context';

export default function useTechnicalErrorHandler(skipContextCheck = false) {
  const handleTechnicalError = useContext(TechnicalErrorContext);

  if (!handleTechnicalError && !skipContextCheck) {
    throw new Error(
      'Technical error context: useTechnicalErrorHandler must be used withing a TechnicalErrorContext',
    );
  }

  return handleTechnicalError;
}
